import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const RankBanner = () => {
  const {language, deviceType, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  const device = deviceType === 'smartphone' ? 'mobile' : 'desktop'

  return (
    <div className={clsx(deviceType !== 'desktop' && `${stylesBydomain.UTILS_MAIN_CONTAINER} utils_main_container`)}>
      <div
        className={clsx(
          'flex items-center py-5 tablet:content-container tablet:mx-auto tablet:rounded-xl',
          stylesBydomain.HOMEPAGE_RANK_BANNER_BG,
          stylesBydomain.HOMEPAGE_RANK_BANNER_TEXT,
          'homepage_rank_banner_text',
          'homepage_rank_banner_bg',
        )}
      >
        <div
          className={clsx(
            'mx-auto flex flex-col items-center justify-center',
            `${stylesBydomain.UTILS_MAIN_CONTAINER} utils_main_container`,
          )}
        >
          <div className="flex flex-row items-center justify-center gap-4 py-2 text-start tablet:flex-col-reverse tablet:gap-1">
            <div className="flex flex-col justify-center gap-2 tablet:items-center tablet:gap-1 tablet:text-center">
              <span className="text-2xl tablet:text-base tablet:font-semibold">
                {translations.Home.RankBanner.title}
              </span>
              <p className="text-base font-light leading-6 tracking-normal">
                {translations.Home.RankBanner.description}
              </p>
            </div>
            <div className="mx-auto flex h-auto w-[480px] shrink-0 grow-0 items-center justify-center tablet:w-[320px]">
              <img
                src={`https://dt47coepsakuj.cloudfront.net/images/${device}/how-do-we-rank.png`}
                alt="headphones-stars"
                loading="lazy"
                className="h-full w-[480px] object-contain tablet:w-[320px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RankBanner
